import { IonIcon } from "@ionic/react";
import { flameOutline } from "ionicons/icons";
import { memo } from "react";

interface CalorieCenterContentProps {
  totalCalories: number;
}

export const CalorieCenterContent = memo(function CalorieCenterContent({
  totalCalories,
}: CalorieCenterContentProps) {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center z-10">
      <IonIcon icon={flameOutline} className="text-gray-700 mb-1 text-2xl" />
      <div className="flex items-baseline gap-1">
        <span className="text-lg font-medium text-black">
          {Math.round(totalCalories)}
        </span>
        <span className="text-sm text-gray-500 font-medium">kcal</span>
      </div>
    </div>
  );
});
